import { render, staticRenderFns } from "./CaseNodeMap.vue?vue&type=template&id=c870f8ac&scoped=true"
import script from "./CaseNodeMap.vue?vue&type=script&lang=js"
export * from "./CaseNodeMap.vue?vue&type=script&lang=js"
import style0 from "./CaseNodeMap.vue?vue&type=style&index=0&id=c870f8ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c870f8ac",
  null
  
)

export default component.exports